import { render, staticRenderFns } from "./GraficoIdiomas.vue?vue&type=template&id=41461cc0&"
import script from "./GraficoIdiomas.vue?vue&type=script&lang=js&"
export * from "./GraficoIdiomas.vue?vue&type=script&lang=js&"
import style0 from "./GraficoIdiomas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports